import React from 'react';

import SharedMonomerConfigurationPageContainer, {
  MONOMER_CONFIGURATION_PURPOSE,
} from './SharedMonomerConfigurationPageContainer';

export {MONOMER_CONFIGURATION_PURPOSE} from './SharedMonomerConfigurationPageContainer';
export type {SharedMonomerConfigurationPageContainerProps} from './SharedMonomerConfigurationPageContainer';

export interface MonomerConfigurationPageContainerProps {
  purpose?: MONOMER_CONFIGURATION_PURPOSE;
  children?: React.ReactNode;
  methodTitle?: string;
}

export default function MonomerConfigurationPageContainer({
  children,
  methodTitle,
  purpose = MONOMER_CONFIGURATION_PURPOSE.CREATE,
}: MonomerConfigurationPageContainerProps): JSX.Element {
  return (
    <SharedMonomerConfigurationPageContainer
      purpose={purpose}
      methodTitle={methodTitle}
      libraryName="Monomer library"
      libraryUrl="/monomers"
      changeMethodUrl="/monomers/create"
    >
      {children}
    </SharedMonomerConfigurationPageContainer>
  );
}
